import {useDebugValue} from 'react';

import {
    getNoUndefArray,
    getKeyedObject,
    getNoUndefObject
} from '../../../utils';

function useStoreData(config, defaultStore, otherStores) {
    const {
        storeDataRef,
        storeKeys
    } = config;

    const {
        [storeDataRef]: defaultData,
    } = defaultStore;

    const otherData = getNoUndefArray(otherStores.map((store) => (
        store[storeDataRef]
    )));

    const specifiedData = otherData.reduce((accumulatedData, currentData) => ({
        ...accumulatedData,
        ...getNoUndefObject(currentData)
    }), {});

    const storeData = getKeyedObject({
        ...defaultData,
        ...specifiedData
    }, storeKeys);

    const result = {
        storeData
    };

    useDebugValue(result);

    return result;
}

export {useStoreData};
